"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@nextui-org/react");
var react_2 = require("react");
var react_redux_1 = require("react-redux");
var upload_inventory_file_1 = require("../../../../../../api/calls/gmc/upload_inventory_file");
var get_channels_thunk_1 = require("../../../../../../reducers/slices/channels/thunks/get_channels_thunk");
var main_1 = require("../../../../../../reducers/slices/main");
var InventoryUploader = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_2.useState)(null), file = _a[0], setFile = _a[1];
    var _b = (0, react_2.useState)(false), isUploading = _b[0], setIsUploading = _b[1];
    var _c = (0, react_2.useState)([]), previewItems = _c[0], setPreviewItems = _c[1];
    var _d = (0, react_redux_1.useSelector)(function (state) { return state.channelState; }), loading = _d.loading, channels = _d.channels;
    var _id = (channels[0] || {})._id;
    var handleUpload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsUploading(true);
                    dispatch((0, main_1.setContentModal)({
                        title: "Uploading...",
                        content: (0, jsx_runtime_1.jsx)(react_1.Spinner, { label: "Uploading inventory file..." }),
                    }));
                    return [4 /*yield*/, (0, upload_inventory_file_1.upload_inventory_file)({ channel_id: _id })];
                case 1:
                    response = _a.sent();
                    if (response.success) {
                        dispatch((0, main_1.setContentModal)({
                            title: "Success",
                            content: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Successfully uploaded inventory file to Google Merchant Center." }),
                        }));
                        setPreviewItems([]);
                        setFile(null);
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({ title: "Upload Error", messages: ["An unexpected error occurred during upload."] }));
                    }
                    setIsUploading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_2.useEffect)(function () {
        dispatch((0, get_channels_thunk_1.get_channels_thunk)({ type: "google_merchant_center" }));
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-col gap-8" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-col gap-4" }, { children: (0, jsx_runtime_1.jsx)(react_1.Button, __assign({ color: "primary", onClick: handleUpload }, { children: isUploading ? "Uploading..." : "Upload to GMC" })) })) })));
};
exports.default = InventoryUploader;
